// Pure client-side validation helpers for the CoreX waitlist form (WAIT-4A).
// Usability support only — NOT a duplicate of backend security.
import { OTHER_CODE, OTHER_TEXT_MAX } from "@/data/waitlistOptions";

// Pragmatic email check (not a backend-grade validator).
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateWaitlist(values) {
  const errors = {};

  if (!values.firstName || values.firstName.trim() === "") {
    errors.firstName = "Please enter your first name.";
  }

  const email = (values.email || "").trim();
  if (!email) {
    errors.email = "Please enter your email address.";
  } else if (!EMAIL_RE.test(email)) {
    errors.email = "Please enter a valid email address.";
  }

  if (!values.personaCodes || values.personaCodes.length === 0) {
    errors.personas = "Select at least one option.";
  }

  if (!values.sportCodes || values.sportCodes.length === 0) {
    errors.sports = "Select at least one sport.";
  }

  if (values.personaCodes && values.personaCodes.includes(OTHER_CODE)) {
    const t = (values.otherPersonaText || "").trim();
    if (!t) {
      errors.otherPersonaText = "Please tell us about your role.";
    } else if (/[\r\n]/.test(values.otherPersonaText || "")) {
      errors.otherPersonaText = "Please use a single line.";
    } else if (t.length > OTHER_TEXT_MAX) {
      errors.otherPersonaText = `Please keep this under ${OTHER_TEXT_MAX} characters.`;
    }
  }

  if (values.sportCodes && values.sportCodes.includes(OTHER_CODE)) {
    const t = (values.otherSportText || "").trim();
    if (!t) {
      errors.otherSportText = "Please tell us which sport.";
    } else if (/[\r\n]/.test(values.otherSportText || "")) {
      errors.otherSportText = "Please use a single line.";
    } else if (t.length > OTHER_TEXT_MAX) {
      errors.otherSportText = `Please keep this under ${OTHER_TEXT_MAX} characters.`;
    }
  }

  if (!values.marketingConsent) {
    errors.marketingConsent = "Please accept to continue.";
  }

  return errors;
}

// Ordered field keys used to focus the first invalid field/group on submit.
export const FIELD_FOCUS_ORDER = [
  "firstName",
  "email",
  "personas",
  "otherPersonaText",
  "sports",
  "otherSportText",
  "marketingConsent",
];
